<div class="table-responsive">
  <table class="table table-striped datatable">
    <thead>
      <tr>
        @for (th of headers; track th) {
          <th [innerHtml]="th.html"></th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track row) {
        @if (row.component['template']) {
          <tr>
            <ng-container [ngTemplateOutlet]="row.component['template']"></ng-container>
          </tr>
        }
        @if (!row.component['template']) {
          <tr [innerHtml]="row.html"></tr>
        }
      }
    </tbody>
  </table>
</div>

<app-simple-table-pagination [totalRows]="totalRows" (currentPageEmitter)="onPageSet($event)">
</app-simple-table-pagination>
